import Spinner from "./spinner";

interface LoadingStateProps {
  label?: string;
  className?: string;
}

/** Placeholder shown while a list or panel is still fetching. */
export default function LoadingState({
  label = "Loading…",
  className = "",
}: LoadingStateProps) {
  return (
    <div
      className={`ib-empty ib-empty--loading${className ? ` ${className}` : ""}`}
      role="status"
    >
      <Spinner size={18} />
      <span>{label}</span>
    </div>
  );
}
